import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient, APIResponse } from '../client';

export interface AdjustInventoryInput {
  ingredientId: string;
  quantity: number;
  reason: string;
  notes?: string;
}

export interface PhysicalCountInput {
  counts: Array<{
    ingredientId: string;
    countedQuantity: number;
  }>;
  notes?: string;
}

// Adjust inventory (manual adjustment)
export function useAdjustInventory(branchId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: AdjustInventoryInput) => {
      const response = await apiClient.post<APIResponse<{ event: any }>>(
        `/inventory/adjust`,
        { ...input, branchId }
      );
      return response.data.data.event;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['inventory'] });
    },
  });
}

// Physical count (update multiple items at once)
export function usePhysicalCount(branchId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: PhysicalCountInput) => {
      const response = await apiClient.post<APIResponse<{ updated: number }>>(
        `/inventory/physical-count`,
        { ...input, branchId }
      );
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['inventory'] });
    },
  });
}
